import { render, staticRenderFns } from "./bidding_create.vue?vue&type=template&id=2591af49&scoped=true&"
import script from "./bidding_create.vue?vue&type=script&lang=js&"
export * from "./bidding_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591af49",
  null
  
)

export default component.exports